// extracted by mini-css-extract-plugin
module.exports = {"suggestToken":"suggest-token-button_suggestToken__VVBlE","button":"suggest-token-button_button__qaUEj"};